import type { FixedNumberArray } from '../../utils';

/**
 * represents the RGBA as an array ranges from 0 - 1
 * white = [1,1,1,1];
 * red = [1,0,0,1];
 * 50% alpha red = [1, 0, 0, 0.5];
 * full clear = [0, 0, 0, 0];
 */
export type ColorArray = FixedNumberArray<4>;

export const CLEAR_COLOR: ColorArray = [0, 0, 0, 0];
